import React from "react";
import connected from "./connected";
import DaysSelect from "../../components/DaysSelect";
import TimeSelect from "../../components/TimeSelect";
import ZoneSelect from "../../components/ZoneSelect";
// import ResetSelect from "../../components/ResetSelect";
import s from "./index.css";

const ConnectedDays = connected(DaysSelect);
const ConnectedTime = connected(TimeSelect);
const ConnectedZone = connected(ZoneSelect);
// const ConnectedReset = connected(ResetSelect);

export default connected(({ editing, setEditing }) => (
  <div className={s.content}>
    <ConnectedDays />
    <ConnectedTime />
    <ConnectedZone />
    {/* <ConnectedReset /> */}
    <div className="d-block m-4" />
  </div>
));



// WEBPACK FOOTER //
// ./src/routes/Home/index.js